import axios from "axios";
import queryString from "query-string";
import {middlewareRequest, middlewareResponse, middlewareResponseError} from "./config";

const COMMON_BASE_URL = `/services/common-service`;
const requestCommon = axios.create({
  baseURL: COMMON_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    serialize: (params) =>
      queryString.stringify(params, { arrayFormat: "comma" }),
  },
});

requestCommon.interceptors.request.use(middlewareRequest, (error) =>
  Promise.reject(error)
);

requestCommon.interceptors.response.use(
  middlewareResponse,
  middlewareResponseError
);

const commonApi = (options) => {
  return requestCommon({
    ...options,
    headers: { "Accept-Language": "vi", ...options.headers },
  });
};

export default commonApi;
